import mixpanel from 'mixpanel-browser';

import config from 'config/site.config';

export interface AnalyticsEvent {
  category: string;
  action: string;
  event_value?: number;
  event_text_value?: string;
  event_source?: string;
}

export const trackAnalyticsEvent = (trackEvent: AnalyticsEvent) => {
  if (config.env === 'development') {
    console.log('Analytics', trackEvent);
  }

  if (config.mixpanelToken) {
    const { action, ...rest } = trackEvent;
    mixpanel.track(action, rest);
  }

  window.dataLayer.push({ ...trackEvent, event: 'custom_event' });
};
